import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=385eafa9&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style0 from "../../../style/exchange-shop/m/common.scss?vue&type=style&index=0&id=385eafa9&prod&lang=scss&scoped=true&external"
import style1 from "./orderList.vue?vue&type=style&index=1&id=385eafa9&prod&lang=scss&scoped=true"
import style2 from "./orderList.vue?vue&type=style&index=2&id=385eafa9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385eafa9",
  null
  
)

export default component.exports